// removed by extract-text-webpack-plugin
module.exports = {"purple":"#9800ff","easeInOutExpo":"cubic-bezier(1,0,0,1)","easeInExpo":"cubic-bezier(.95,.05,.795,.035)","content":"profileNav__content___1TCsq","enter":"profileNav__enter___1s_BQ","enterActive":"profileNav__enterActive___2qUu0","leave":"profileNav__leave___oKiZQ","leaveActive":"profileNav__leaveActive___3uKwI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfileNav/profileNav.css
// module id = 164
// module chunks = 0